import BaseEntity from '../../base/BaseEntity.model';
import Documento from '@/models/documento.model';

export default class SolicitudCambioComposicionFamiliarDocumento extends BaseEntity {
    public solicitudCambioComposicionFamiliarInclusionId?: number;
    public solicitudCambioComposicionFamiliarExclusionId?: number;
    public solicitudCambioComposicionFamiliarCorreccionId?: number;
    public personaId?: number;
    public documentoId?: number;
    public documento?: Documento;
    public tipoDocumentoId?: number;
    public tipoDocumentoNombre?: string;

    constructor() {
        super();
        this.solicitudCambioComposicionFamiliarCorreccionId = undefined;
        this.solicitudCambioComposicionFamiliarExclusionId = undefined;
        this.solicitudCambioComposicionFamiliarExclusionId = undefined;
        this.personaId = undefined;
        this.documentoId = undefined;
        this.documento = undefined;
        this.tipoDocumentoId = undefined;
        this.tipoDocumentoNombre = undefined;
    }
}